<template>
  <div class="results-widget">
    <v-subheader>{{ lang.items.results.title }}</v-subheader>
    <v-row
      v-for="(result, i) in results"
      :key="i"
      class="result"
    >
      <v-col cols="9" class="result-label">
        {{ lang.items.results[i] }}
      </v-col>
      <v-col cols="3" class="result-text">
        {{ result }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  props: {
    customData: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    data () {
      return (this.customData ? (this.socketInfo.custom_data ? this.socketInfo.custom_data.items : []) : (this.get_data ? this.get_data.catalog : []))
    },
    results () {
      return {
        all: (this.data || []).length,
        deleted: (this.data.filter(el => el.deleted === 1) || []).length
      }
    }
  }
}
</script>
